<template>
  <div
    :class="addClass + ' nh-btn' + (version ? ` version-${version}` : '')"
    :style="`--icon: url(${icon})`"
    @click="link ? null : $emit('click')"
  >
    <b-spinner
      v-if="loader"
      small
      label="small spinner"
    />
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    addClass: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: null
    },
    loader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    version: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

<style scoped lang="scss">
  .nh-btn {
    cursor: pointer;
    color: black;
    border: 2px solid;
    border-radius: 0.313rem;
    border-color: $warning;
    background-color: $warning;
    padding: 0.6rem 0.1rem;
    padding-right: 1.2rem;
    display: inline-block;
    transition: ease-in-out 0.2s;
    min-width: 112px;
    text-align: center;
    font-size: 0.625rem;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    &:hover {
      text-decoration: none;
      color: white !important;
      &:after {
        transform: scale(1.15);
      }
    }

    &:after {
      content: '';
      transition: 0.2s;
      display: block;
      position: absolute;
      right: 8px;
      top: calc(48% - 9px);
      width: 18px;
      height: 18px;
      background-image: var(--icon);
      background-repeat: no-repeat;
      background-position: center;
      background-size: 16px;
    }
  }

  .spinner-border {
    margin-right: 0.5rem;
  }

  .version-white{
    background-color: white;
    transition: 0.3s;
    &:hover {
      background-color: $warning;
    }
  }
</style>
